export default "images/实时路线导航+标志牌增强显示+风险物体提示+前车风险提示.png";